package fr.manyverse.app.presentation.components.gm_screen

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.Announcement
import androidx.compose.material.icons.automirrored.filled.MenuBook
import androidx.compose.material.icons.automirrored.filled.TextSnippet
import androidx.compose.material.icons.filled.Backpack
import androidx.compose.material.icons.filled.Casino
import androidx.compose.material.icons.filled.DeleteForever
import androidx.compose.material.icons.filled.Dialpad
import androidx.compose.material.icons.filled.Draw
import androidx.compose.material.icons.filled.ExpandLess
import androidx.compose.material.icons.filled.ExpandMore
import androidx.compose.material.icons.filled.Forum
import androidx.compose.material.icons.filled.Groups3
import androidx.compose.material.icons.filled.Key
import androidx.compose.material.icons.filled.PersonAdd
import androidx.compose.material.icons.filled.PersonRemove
import androidx.compose.material.icons.filled.Timer
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.Card
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ElevatedCard
import androidx.compose.material3.FilledIconButton
import androidx.compose.material3.FilledTonalIconButton
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.IconButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import fr.manyverse.app.domain.model.Character
import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.model.GameEvent
import fr.manyverse.app.domain.model.GameTable
import fr.manyverse.app.domain.model.MemberRole
import fr.manyverse.app.domain.model.TableMember
import fr.manyverse.app.presentation.components.CharacterAvatar
import fr.manyverse.app.presentation.components.ZoomableImageDialog
import fr.manyverse.app.presentation.components.common_tabs.GameCodeCard
import fr.manyverse.app.presentation.components.common_tabs.HomeButton
import fr.manyverse.app.presentation.components.common_tabs.TableInfoCard
import fr.manyverse.app.presentation.components.common_tabs.ToolItem
import fr.manyverse.app.presentation.components.common_tabs.ToolsSection
import fr.manyverse.app.presentation.state.AsyncUiState
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.format.char
import kotlinx.datetime.toLocalDateTime
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.characters
import manyverse.shared.generated.resources.collapse
import manyverse.shared.generated.resources.delete_table
import manyverse.shared.generated.resources.event_author_game_master
import manyverse.shared.generated.resources.event_author_unknown_player
import manyverse.shared.generated.resources.event_combat_started
import manyverse.shared.generated.resources.event_dice_rolled
import manyverse.shared.generated.resources.event_digicode_launched
import manyverse.shared.generated.resources.event_format_announcement_all
import manyverse.shared.generated.resources.event_format_announcement_some
import manyverse.shared.generated.resources.event_format_message_sent
import manyverse.shared.generated.resources.event_format_timer_all
import manyverse.shared.generated.resources.event_format_timer_some
import manyverse.shared.generated.resources.event_format_whiteboard_all
import manyverse.shared.generated.resources.event_format_whiteboard_some
import manyverse.shared.generated.resources.event_lockpicking_launched
import manyverse.shared.generated.resources.event_player_joined
import manyverse.shared.generated.resources.event_format_item_sent
import manyverse.shared.generated.resources.event_format_player_joined
import manyverse.shared.generated.resources.expand
import manyverse.shared.generated.resources.item_sender_game_master
import manyverse.shared.generated.resources.event_player_kicked
import manyverse.shared.generated.resources.event_safety_alert
import manyverse.shared.generated.resources.events
import manyverse.shared.generated.resources.events_empty
import manyverse.shared.generated.resources.gm_inventory
import manyverse.shared.generated.resources.icon_sword_cross
import manyverse.shared.generated.resources.icon_treasure_chest
import manyverse.shared.generated.resources.load_more_events
import manyverse.shared.generated.resources.premade_characters
import manyverse.shared.generated.resources.remove_player
import manyverse.shared.generated.resources.view_character_sheet
import manyverse.shared.generated.resources.view_inventory
import manyverse.shared.generated.resources.view_notes
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import kotlin.math.abs
import kotlin.time.Clock
import kotlin.time.Instant

@Composable
fun GmTableTab(
    table: GameTable,
    characters: List<Character>,
    onInventoryClick: (Character) -> Unit,
    showInventoryButton: Boolean,
    showSheetButton: Boolean,
    onNotesClick: (Character) -> Unit,
    onSheetClick: (Character) -> Unit,
    events: List<GameEvent>,
    eventsState: AsyncUiState<*>,
    hasMoreEvents: Boolean,
    loadMoreEventsState: AsyncUiState<Unit>,
    totalPlayersCount: Int,
    tableMembers: List<TableMember>,
    onLoadEvents: () -> Unit,
    onLoadMoreEvents: () -> Unit,
    kickState: AsyncUiState<Unit>,
    onKickPlayer: (userId: String) -> Unit,
    onResetKickState: () -> Unit,
    deleteTableState: AsyncUiState<Unit>,
    onDeleteTable: () -> Unit,
    onResetDeleteTableState: () -> Unit,
    renameTableState: AsyncUiState<Unit>,
    onRenameTable: (String) -> Unit,
    onResetRenameTableState: () -> Unit,
    onNavigateBack: () -> Unit,
    onManagePreMades: () -> Unit,
    onGmInventoryClick: () -> Unit,
    diceTotalEnabled: Boolean,
    modifier: Modifier = Modifier
) {
    var showDeleteDialog by rememberSaveable { mutableStateOf(false) }
    var showRenameDialog by rememberSaveable { mutableStateOf(false) }
    var displayedName by remember(table.name) { mutableStateOf(table.name) }
    var pendingName by remember { mutableStateOf("") }

    LaunchedEffect(deleteTableState) {
        if (deleteTableState is AsyncUiState.Success) {
            showDeleteDialog = false
            onResetDeleteTableState()
        }
    }

    LaunchedEffect(renameTableState) {
        if (renameTableState is AsyncUiState.Success) {
            displayedName = pendingName
            showRenameDialog = false
            onResetRenameTableState()
        }
    }

    if (showDeleteDialog) {
        DeleteGameDialog(
            isLoading = deleteTableState is AsyncUiState.Loading,
            errorMessage = (deleteTableState as? AsyncUiState.Error)?.message,
            onConfirm = onDeleteTable,
            onDismiss = {
                showDeleteDialog = false
                onResetDeleteTableState()
            }
        )
    }

    if (showRenameDialog) {
        RenameGameTableDialog(
            currentName = displayedName,
            updateState = renameTableState,
            onConfirm = {
                pendingName = it
                onRenameTable(it)
            },
            onDismiss = {
                showRenameDialog = false
                onResetRenameTableState()
            }
        )
    }

    Column(
        modifier = modifier
            .fillMaxSize()
            .verticalScroll(rememberScrollState()),
        verticalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        Box(modifier = Modifier.fillMaxWidth()) {
            HomeButton(
                onNavigateBack = onNavigateBack,
                modifier = Modifier.align(Alignment.CenterStart)
            )
            GameCodeCard(
                code = table.code,
                modifier = Modifier.align(Alignment.Center)
            )
            FilledTonalIconButton(
                onClick = { showDeleteDialog = true },
                modifier = Modifier.align(Alignment.CenterEnd),
                colors = IconButtonDefaults.filledTonalIconButtonColors(
                    containerColor = MaterialTheme.colorScheme.errorContainer
                )
            ) {
                Icon(
                    imageVector = Icons.Default.DeleteForever,
                    contentDescription = stringResource(Res.string.delete_table),
                    tint = MaterialTheme.colorScheme.onErrorContainer
                )
            }
        }

        // Table Info Card
        TableInfoCard(
            table = table,
            displayName = displayedName,
            onEditName = { showRenameDialog = true }
        )

        // Tools section (collapsible)
        GmToolsSection(onManagePreMades = onManagePreMades, onGmInventoryClick = onGmInventoryClick)

        // Characters section (collapsible)
        CharactersSection(
            characters = characters,
            tableMembers = tableMembers,
            onInventoryClick = onInventoryClick,
            showInventoryButton = showInventoryButton,
            showSheetButton = showSheetButton,
            onNotesClick = onNotesClick,
            onSheetClick = onSheetClick,
            kickState = kickState,
            onKickPlayer = onKickPlayer,
            onResetKickState = onResetKickState
        )

        // Events section (collapsible)
        EventsSection(
            events = events,
            eventsState = eventsState,
            hasMoreEvents = hasMoreEvents,
            loadMoreEventsState = loadMoreEventsState,
            totalPlayersCount = totalPlayersCount,
            tableMembers = tableMembers,
            characters = characters,
            diceTotalEnabled = diceTotalEnabled,
            onLoadEvents = onLoadEvents,
            onLoadMoreEvents = onLoadMoreEvents
        )
    }
}

@Composable
private fun GmToolsSection(onManagePreMades: () -> Unit, onGmInventoryClick: () -> Unit) {
    ToolsSection {
        ToolItem(
            painter = rememberVectorPainter(Icons.Default.Groups3),
            label = stringResource(Res.string.premade_characters),
            onClick = onManagePreMades
        )
        ToolItem(
            painter = painterResource(Res.drawable.icon_treasure_chest),
            label = stringResource(Res.string.gm_inventory),
            onClick = onGmInventoryClick
        )
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun CharactersSection(
    characters: List<Character>,
    tableMembers: List<TableMember>,
    onInventoryClick: (Character) -> Unit,
    showInventoryButton: Boolean,
    showSheetButton: Boolean,
    onNotesClick: (Character) -> Unit,
    onSheetClick: (Character) -> Unit,
    kickState: AsyncUiState<Unit>,
    onKickPlayer: (userId: String) -> Unit,
    onResetKickState: () -> Unit
) {
    var expanded by rememberSaveable { mutableStateOf(true) }
    var memberToKick by remember { mutableStateOf<Pair<String, String>?>(null) }

    LaunchedEffect(kickState) {
        if (kickState is AsyncUiState.Success) {
            memberToKick = null
            onResetKickState()
        }
    }

    memberToKick?.let { (userId, characterName) ->
        RemovePlayerDialog(
            characterName = characterName,
            isLoading = kickState is AsyncUiState.Loading,
            errorMessage = (kickState as? AsyncUiState.Error)?.message,
            onConfirm = { onKickPlayer(userId) },
            onDismiss = {
                memberToKick = null
                onResetKickState()
            }
        )
    }

    Card(modifier = Modifier.fillMaxWidth()) {
        Column(modifier = Modifier.fillMaxWidth()) {
            // Header
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable { expanded = !expanded }
                    .padding(start = 16.dp, end = 8.dp, top = 8.dp, bottom = 8.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = stringResource(Res.string.characters),
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.SemiBold
                )
                Icon(
                    imageVector = if (expanded) Icons.Default.ExpandLess else Icons.Default.ExpandMore,
                    contentDescription = stringResource(if (expanded) Res.string.collapse else Res.string.expand)
                )
            }

            AnimatedVisibility(visible = expanded) {
                FlowRow(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(start = 12.dp, end = 12.dp, bottom = 12.dp),
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    characters.sortedBy { it.name }.forEach { character ->
                        val member = tableMembers.find { it.characterId == character.id }
                        CharacterGmCard(
                            character = character,
                            onInventoryClick = { onInventoryClick(character) },
                            showInventoryButton = showInventoryButton,
                            showSheetButton = showSheetButton,
                            onNotesClick = { onNotesClick(character) },
                            onSheetClick = { onSheetClick(character) },
                            onRemoveClick = member?.let {
                                {
                                    memberToKick = Pair(it.userId, character.name)
                                }
                            }
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun EventsSection(
    events: List<GameEvent>,
    eventsState: AsyncUiState<*>,
    hasMoreEvents: Boolean,
    loadMoreEventsState: AsyncUiState<Unit>,
    totalPlayersCount: Int,
    tableMembers: List<TableMember>,
    characters: List<Character>,
    diceTotalEnabled: Boolean,
    onLoadEvents: () -> Unit,
    onLoadMoreEvents: () -> Unit
) {
    var expanded by rememberSaveable { mutableStateOf(true) }

    LaunchedEffect(Unit) {
        onLoadEvents()
    }

    Card(modifier = Modifier.fillMaxWidth()) {
        Column(modifier = Modifier.fillMaxWidth()) {
            // Header
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable { expanded = !expanded }
                    .padding(16.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = stringResource(Res.string.events),
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.SemiBold
                )
                Icon(
                    imageVector = if (expanded) Icons.Default.ExpandLess else Icons.Default.ExpandMore,
                    contentDescription = stringResource(if (expanded) Res.string.collapse else Res.string.expand)
                )
            }

            AnimatedVisibility(visible = expanded) {
                when (eventsState) {
                    is AsyncUiState.Loading -> {
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(16.dp),
                            contentAlignment = Alignment.Center
                        ) {
                            CircularProgressIndicator()
                        }
                    }

                    is AsyncUiState.Error -> {
                        Text(
                            text = eventsState.message,
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.error,
                            textAlign = TextAlign.Center,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(16.dp)
                        )
                    }

                    is AsyncUiState.Success, is AsyncUiState.Idle -> {
                        if (events.isEmpty()) {
                            Text(
                                text = stringResource(Res.string.events_empty),
                                style = MaterialTheme.typography.bodyMedium,
                                color = MaterialTheme.colorScheme.onSurfaceVariant,
                                textAlign = TextAlign.Center,
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(16.dp)
                            )
                        } else {
                            Column(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(start = 8.dp, end = 8.dp, bottom = 8.dp),
                                verticalArrangement = Arrangement.spacedBy(4.dp)
                            ) {
                                events.forEach { event ->
                                    EventCard(
                                        event = event,
                                        totalPlayersCount = totalPlayersCount,
                                        tableMembers = tableMembers,
                                        characters = characters,
                                        diceTotalEnabled = diceTotalEnabled
                                    )
                                }
                                if (hasMoreEvents) {
                                    Box(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .padding(top = 4.dp),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        when (loadMoreEventsState) {
                                            is AsyncUiState.Loading -> CircularProgressIndicator()
                                            is AsyncUiState.Error -> Text(
                                                text = loadMoreEventsState.message,
                                                style = MaterialTheme.typography.bodySmall,
                                                color = MaterialTheme.colorScheme.error,
                                                textAlign = TextAlign.Center
                                            )

                                            else -> OutlinedButton(onClick = onLoadMoreEvents) {
                                                Text(stringResource(Res.string.load_more_events))
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun CharacterGmCard(
    character: Character,
    onInventoryClick: () -> Unit,
    showInventoryButton: Boolean,
    showSheetButton: Boolean,
    onNotesClick: () -> Unit,
    onSheetClick: () -> Unit,
    onRemoveClick: (() -> Unit)?
) {
    var showAvatarFullscreen by remember { mutableStateOf(false) }
    var expanded by rememberSaveable { mutableStateOf(false) }

    Box(
        modifier = if (expanded) Modifier.fillMaxWidth() else Modifier.width(160.dp)
    ) {
        ElevatedCard(
            modifier = Modifier.fillMaxWidth()
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 12.dp, bottom = 8.dp, start = 8.dp, end = 8.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                Box(modifier = Modifier.fillMaxWidth()) {
                    CharacterAvatar(
                        imageUrl = character.signedImageUrl,
                        characterName = character.name,
                        size = 56.dp,
                        onClick = if (character.signedImageUrl != null) {
                            { showAvatarFullscreen = true }
                        } else null,
                        modifier = Modifier.align(Alignment.Center)
                    )
                    IconButton(
                        onClick = { expanded = !expanded },
                        modifier = Modifier.align(Alignment.CenterStart)
                    ) {
                        Icon(
                            imageVector = if (expanded) Icons.Default.ExpandLess else Icons.Default.ExpandMore,
                            contentDescription = stringResource(if (expanded) Res.string.collapse else Res.string.expand)
                        )
                    }
                }

                Text(
                    text = character.name,
                    style = MaterialTheme.typography.titleSmall,
                    textAlign = TextAlign.Center,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.fillMaxWidth()
                )

                AnimatedVisibility(visible = expanded) {
                    Column(
                        modifier = Modifier.fillMaxWidth(),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        if (showInventoryButton) {
                            CharacterActionItem(
                                icon = Icons.Default.Backpack,
                                label = stringResource(Res.string.view_inventory),
                                onClick = onInventoryClick
                            )
                        }
                        CharacterActionItem(
                            icon = Icons.AutoMirrored.Filled.TextSnippet,
                            label = stringResource(Res.string.view_notes),
                            onClick = onNotesClick
                        )
                        if (showSheetButton) {
                            CharacterActionItem(
                                icon = Icons.AutoMirrored.Filled.MenuBook,
                                label = stringResource(Res.string.view_character_sheet),
                                onClick = onSheetClick
                            )
                        }
                    }
                }
            }
        }
        if (expanded && onRemoveClick != null) {
            IconButton(
                onClick = onRemoveClick,
                modifier = Modifier.align(Alignment.TopEnd)
            ) {
                Icon(
                    imageVector = Icons.Default.PersonRemove,
                    contentDescription = stringResource(Res.string.remove_player),
                    tint = MaterialTheme.colorScheme.error
                )
            }
        }
    }

    if (showAvatarFullscreen && character.signedImageUrl != null) {
        ZoomableImageDialog(
            imageUrl = character.signedImageUrl,
            contentDescription = character.name,
            onDismiss = { showAvatarFullscreen = false }
        )
    }
}

@Composable
private fun CharacterActionItem(
    icon: ImageVector,
    label: String,
    onClick: () -> Unit
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
    ) {
        FilledIconButton(
            onClick = onClick,
            colors = IconButtonDefaults.filledIconButtonColors(MaterialTheme.colorScheme.primaryContainer)
        ) {
            Icon(
                imageVector = icon,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onPrimaryContainer
            )
        }
        Text(
            text = label,
            style = MaterialTheme.typography.labelLarge,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
private fun EventCard(
    event: GameEvent,
    totalPlayersCount: Int,
    tableMembers: List<TableMember>,
    characters: List<Character>,
    diceTotalEnabled: Boolean,
    modifier: Modifier = Modifier
) {
    val dateTimeText = formatDateTime(event.createdAt)

    val author = tableMembers.find { it.userId == event.triggeredBy }
    val gameMasterText = stringResource(Res.string.event_author_game_master)
    val unknownPlayerText = stringResource(Res.string.event_author_unknown_player)
    val authorText = when (author?.role) {
        MemberRole.GAME_MASTER -> gameMasterText
        MemberRole.PLAYER -> characters.find { it.userId == author.userId }?.name
            ?: unknownPlayerText

        else -> unknownPlayerText
    }

    val eventDescription = when (event.eventType) {
        EventType.ANNOUNCEMENT -> {
            if (event.targetParticipants.size >= totalPlayersCount) {
                stringResource(Res.string.event_format_announcement_all)
            } else {
                stringResource(
                    Res.string.event_format_announcement_some,
                    event.targetParticipants.size
                )
            }
        }

        EventType.WHITEBOARD_OPENED -> {
            if (event.targetParticipants.size >= totalPlayersCount) {
                stringResource(Res.string.event_format_whiteboard_all)
            } else {
                stringResource(
                    Res.string.event_format_whiteboard_some,
                    event.targetParticipants.size
                )
            }
        }

        EventType.TIMER_STARTED -> {
            if (event.targetParticipants.size >= totalPlayersCount) {
                stringResource(Res.string.event_format_timer_all)
            } else {
                stringResource(
                    Res.string.event_format_timer_some,
                    event.targetParticipants.size
                )
            }
        }

        EventType.DIGICODE_LAUNCHED -> stringResource(Res.string.event_digicode_launched)
        EventType.LOCKPICKING_LAUNCHED -> stringResource(Res.string.event_lockpicking_launched)
        EventType.MESSAGE_SENT -> {
            val content = event.content as? EventContent.MessageSent
            val recipientNames = event.targetParticipants.joinToString(", ") { userId ->
                val recipient = tableMembers.find { it.userId == userId }
                when (recipient?.role) {
                    MemberRole.GAME_MASTER -> gameMasterText
                    else -> characters.find { it.userId == userId }?.name ?: unknownPlayerText
                }
            }
            val sentTo = stringResource(Res.string.event_format_message_sent, authorText, recipientNames)
            if (content != null) "$sentTo — « ${content.text} »" else sentTo
        }

        EventType.DICE_ROLLED -> {
            val content = event.content as? EventContent.DiceRolled
            if (content != null) {
                val diceLabel =
                    if (content.count > 1) "${content.count}×${content.dieType}" else content.dieType
                if (diceTotalEnabled) {
                    val total = content.results.sum() + content.modifier
                    // Le détail n'a d'intérêt que s'il diffère du total (plusieurs dés ou modificateur).
                    val breakdown = if (content.results.size > 1 || content.modifier != 0) {
                        val sign = if (content.modifier >= 0) "+" else "−"
                        val modifierPart =
                            if (content.modifier != 0) "$sign${abs(content.modifier)}" else ""
                        " (${content.results.joinToString("+")}$modifierPart)"
                    } else ""
                    "$diceLabel : $total$breakdown"
                } else {
                    "$diceLabel : ${content.results.joinToString(", ")}"
                }
            } else {
                stringResource(Res.string.event_dice_rolled)
            }
        }

        EventType.PLAYER_JOINED -> {
            val content = event.content as? EventContent.PlayerJoined
            if (content != null) {
                stringResource(Res.string.event_format_player_joined, content.characterName)
            } else {
                "($authorText) ${stringResource(Res.string.event_player_joined)}"
            }
        }
        EventType.PLAYER_KICKED -> stringResource(Res.string.event_player_kicked)
        EventType.PLAYER_ALERT -> stringResource(Res.string.event_safety_alert)
        EventType.GM_ALERT -> stringResource(Res.string.event_safety_alert)
        EventType.COMBAT_STARTED -> stringResource(Res.string.event_combat_started)
        EventType.ITEM_SENT -> {
            val content = event.content as? EventContent.ItemSent
            if (content != null) {
                val itemLabel =
                    if (content.quantity > 1) "${content.itemName} ×${content.quantity}" else content.itemName
                stringResource(
                    Res.string.event_format_item_sent,
                    content.senderName ?: stringResource(Res.string.item_sender_game_master),
                    content.recipientNames.joinToString(", "),
                    itemLabel
                )
            } else ""
        }
        EventType.ANNOUNCEMENT_CANCELLED -> ""
    }

    val eventIcon: Painter = when (event.eventType) {
        EventType.ANNOUNCEMENT -> rememberVectorPainter(Icons.AutoMirrored.Filled.Announcement)
        EventType.WHITEBOARD_OPENED -> rememberVectorPainter(Icons.Default.Draw)
        EventType.TIMER_STARTED -> rememberVectorPainter(Icons.Default.Timer)
        EventType.DIGICODE_LAUNCHED -> rememberVectorPainter(Icons.Default.Dialpad)
        EventType.LOCKPICKING_LAUNCHED -> rememberVectorPainter(Icons.Default.Key)
        EventType.MESSAGE_SENT -> rememberVectorPainter(Icons.Default.Forum)
        EventType.DICE_ROLLED -> rememberVectorPainter(Icons.Default.Casino)
        EventType.PLAYER_JOINED -> rememberVectorPainter(Icons.Default.PersonAdd)
        EventType.PLAYER_KICKED -> rememberVectorPainter(Icons.Default.PersonRemove)
        EventType.PLAYER_ALERT -> rememberVectorPainter(Icons.Default.Warning)
        EventType.GM_ALERT -> rememberVectorPainter(Icons.Default.Warning)
        EventType.COMBAT_STARTED -> painterResource(Res.drawable.icon_sword_cross)
        EventType.ITEM_SENT -> rememberVectorPainter(Icons.Default.Backpack)
        EventType.ANNOUNCEMENT_CANCELLED -> rememberVectorPainter(Icons.AutoMirrored.Filled.Announcement)
    }

    Row(
        modifier = modifier
            .fillMaxWidth()
            .padding(vertical = 4.dp, horizontal = 8.dp),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            painter = eventIcon,
            contentDescription = null,
            tint = MaterialTheme.colorScheme.secondary,
            modifier = Modifier.size(18.dp)
        )
        Text(
            // Ces descriptions nomment déjà l'auteur
            text = if (event.eventType in AUTHOR_IN_DESCRIPTION_EVENT_TYPES) {
                "$dateTimeText $eventDescription"
            } else {
                "$dateTimeText ($authorText) $eventDescription"
            },
            style = MaterialTheme.typography.bodyMedium
        )
    }
}

// Évènements dont la description commence par le nom de l'auteur : pas de "(auteur)" en préfixe
private val AUTHOR_IN_DESCRIPTION_EVENT_TYPES = setOf(
    EventType.ITEM_SENT,
    EventType.PLAYER_JOINED,
    EventType.MESSAGE_SENT
)

private val timeFormat = LocalDateTime.Format {
    hour()
    char(':')
    minute()
    char(':')
    second()
}

private val dateTimeFormat = LocalDateTime.Format {
    day()
    char('/')
    monthNumber()
    char('/')
    year()
    char(' ')
    hour()
    char(':')
    minute()
    char(':')
    second()
}

// Heure seule pour un évènement du jour, date et heure sinon
private fun formatDateTime(instant: Instant): String {
    val timeZone = TimeZone.currentSystemDefault()
    val dateTime = instant.toLocalDateTime(timeZone)
    val today = Clock.System.now().toLocalDateTime(timeZone).date
    return dateTime.format(if (dateTime.date == today) timeFormat else dateTimeFormat)
}
